<script setup>
import { FilterMatchMode } from '@primevue/core/api';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useDataTableStore } from '@stores/useDataTableStore';
import { useScreensizeStore } from '@stores/useScreensizeStore';
import {
  PAY_UBIQ_BILLING_DOCUMENTS_ENDPOINT,
  URL_MANAGEMENT_INVOICES,
} from '@tools/routes/routes';
import { trans } from '@elements/translation';
import { BILLING_DOCUMENT_INVOICE_TYPE } from '../constants/constants';
import { useAccountStore } from '../store/account';
import UbiqInvoiceDataList from './UbiqInvoiceDataList.vue';
import UbiqInvoiceTable from './UbiqInvoiceDataTable.vue';
import InvoiceFilters from './InvoiceFilters.vue';

const accountStore = useAccountStore();
const { isMobile } = storeToRefs(useScreensizeStore());
const route = useRoute();

const { addFilter, setDefaultOrder, setEndpoint } = useDataTableStore();

setEndpoint(PAY_UBIQ_BILLING_DOCUMENTS_ENDPOINT);
setDefaultOrder('billingDocument.createdAt', 'desc');

const filterMode = route.path === URL_MANAGEMENT_INVOICES
  ? FilterMatchMode.NOT_EQUALS
  : FilterMatchMode.EQUALS;

addFilter('type', BILLING_DOCUMENT_INVOICE_TYPE.ADAF_FEE, filterMode);

accountStore.setStripeAccountStatus(window.initialState.stripeAccountStatus);

const pageTitle = computed(() => trans(route.meta?.titleKey ?? 'gestion.invoices.title'));
</script>

<template>
  <div class="invoices">
    <div class="invoices__content">
      <div class="invoices__header">
        <div class="invoices__header-title">
          {{ pageTitle }}
        </div>
      </div>
      <InvoiceFilters />
      <UbiqInvoiceDataList v-if="isMobile" />
      <UbiqInvoiceTable v-else />
    </div>
  </div>
</template>
